import { isShareFolderToken } from '@signa/shared';
import { isValidToken } from '../shared/api.js';

/**
 * 単体ページで開くもの(#267)。**盤面のトークン(`pv_`)か、共有フォルダのトークン(`pf_`)か。**
 *
 * **接頭辞で開き方を分ける**([ADR-0045](../../../../docs/adr/0045-share-folder-links.md) の決定 7)。
 * 共有 URL はどちらも `?token=` の形で、ビューアは URL だけで決められる。
 */
export type PageEntry =
  | { readonly kind: 'template'; readonly token: string }
  | { readonly kind: 'folder'; readonly token: string };

/**
 * V02(単体ページ)のトークン取得。
 *
 * **V01 との差分はここだけ**([#33](../../../../docs/issues/33-viewer-embed/DESIGN.md)
 * の「V01 と V02 の差分」)。V01 は `data-signa-preview` 属性、V02 は URL。
 *
 * 対応する形(盤面と共有フォルダのどちらも):
 * - `/v/pv_xxx`(配信時のパス)
 * - `/?token=pv_xxx`(開発サーバ・共有 URL)
 *
 * **形の合わないものは `null`**(公開 API を叩く前に止める)。
 */
export function tokenFromLocation(location: {
  readonly pathname: string;
  readonly search: string;
}): PageEntry | null {
  const fromQuery = entryOf(new URLSearchParams(location.search).get('token'));
  if (fromQuery !== null) return fromQuery;

  // パスの最後のセグメントを見る。`/v/pv_xxx` にも `/pv_xxx` にも対応する。
  const segments = location.pathname.split('/').filter((s) => s !== '');
  return entryOf(segments[segments.length - 1]);
}

function entryOf(raw: string | null | undefined): PageEntry | null {
  if (isValidToken(raw)) return { kind: 'template', token: raw };
  if (isShareFolderToken(raw)) return { kind: 'folder', token: raw };
  return null;
}
